<div class="w-full flex flex-col items-start text-white">
  <h2 class="text-36 sm:text-42 font-bold leading-115">{{ slotable.title }}</h2>
  <div class="mt-4 font-medium text-16 sm:text-20 leading-160 sm:mr-2/24" [innerHtml]="slotable.description"></div>
  <a appFlLink={{slotable.url}}
     class="text-primary bg-white rounded-8 font-bold px-8 py-4 hover:bg-opacity-80 mt-8">
    Learn more
  </a>
</div>
